export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11924.9e3b00bc.jpg";